module.exports = __webpack_public_path__ + "static/media/dood.1c636853.png";